import { contentFreeList } from "../../../Data/Data";
import ListFreeContent from "../ListFreeContent/ListFreeContent";

function ScreenFreeContent({ activeTab }) {

    const list00 = []
    const list01 = []
    const list02 = []
    const list03 = []
    const list04 = []
    const list05 = []
    const list06 = []
    const list07 = []
    const list08 = []
    const list09 = []
    const list10 = []

    {
        contentFreeList.map((item, index) => {
            if (item.type === 'علم و تکنولوژی')
                list00.push(item)
            if (item.type === 'داستانی')
                list01.push(item)
            if (item.type === 'روانشناسی')
                list02.push(item)
            if (item.type === 'اقتصاد')
                list03.push(item)
            if (item.type === 'مدیریت')
                list04.push(item)
            if (item.type === 'اجتماعی')
                list05.push(item)
            if (item.type === 'تاریخی')
                list06.push(item)
            if (item.type === 'سلامت')
                list07.push(item)
            if (item.type === 'فلسفه')
                list08.push(item)
            if (item.type === 'موفقیت')
                list09.push(item)
            if (item.type === 'زندگی نامه')
                list10.push(item)
        })
    }

    return (
        <>
            <ListFreeContent activeTab={activeTab} />
            {/* {(activeTab === 0) ?
                <ListFreeContent list={list00} />
                :
                (activeTab === 1) ?
                    <ListFreeContent list={list01} />
                    :
                    (activeTab === 2) ?
                        <ListFreeContent list={list02} />
                        :
                        (activeTab === 3) ?
                            <ListFreeContent list={list03} />
                            :
                            (activeTab === 4) ?
                                <ListFreeContent list={list04} />
                                :
                                (activeTab === 5) ?
                                    <ListFreeContent list={list05} />
                                    :
                                    (activeTab === 6) ?
                                        <ListFreeContent list={list06} />
                                        :
                                        (activeTab === 7) ?
                                            <ListFreeContent list={list07} />
                                            :
                                            (activeTab === 8) ?
                                                <ListFreeContent list={list08} />
                                                :
                                                (activeTab === 9) ?
                                                    <ListFreeContent list={list09} />
                                                    :
                                                    (activeTab === 10) ?
                                                        <ListFreeContent list={list10} />
                                                        :
                                                        null
            } */}
        </>
    )
}
export default ScreenFreeContent;